import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import Particles from "./components/Particles.js";

/**
 * Sizes
 */
const calculateSizes = () => {
  const sizeValue = {};
  if (window.innerWidth > window.innerHeight) {
    // Landscape
    sizeValue.width = (window.innerHeight * 0.6) * (16 / 9);
    sizeValue.height = (window.innerHeight * 0.6);
  } else {
    // Portrait
    sizeValue.width = window.innerWidth * 0.8;
    sizeValue.height = window.innerWidth * 0.8;
  }
  return sizeValue;
};

const sizes = {
  width: calculateSizes().width,
  height: calculateSizes().height,
};

/**
 * Base
 */
// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

// Create particles
const particles = new Particles(scene, sizes);
particles.init();

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  50,
  sizes.width / sizes.height,
  1,
  10000
);
camera.position.z = 200;
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Handle window resize
 */
window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = calculateSizes().width;
  sizes.height = calculateSizes().height;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  // Update particle system scale
  particles.resize();
});

/**
 * Animate
 */
const clock = new THREE.Clock();

const tick = () => {
  const elapsedTime = clock.getElapsedTime();

  // Update particles
  particles.update(elapsedTime);

  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

/**
 * Mouse move event
 */
const onMouseMove = (event) => {
  particles.onMouseMove(event, camera, renderer);
};

// Add event listeners
window.addEventListener("mousemove", onMouseMove);

tick();
